<template>
    <div :class="['joinus-cta']">
        <div class="block">
            <h2 v-html="layout.title"/>
            <Cta
                :type="'button'"
                :colors="{ hover: { background: '#114991' } }"
                @click.native="goToLast"
            >
                {{layout.caption}}
            </Cta>
        </div>
    </div>
</template>

<script>
import Cta from '@/components/Cta'
export default {
    components: {
        Cta
    },
    props: {
        layout: {
            type: Object,
            default() {}
        }
    },
    methods: {
        goToLast() {
            const d = this.$el.parentNode.lastChild.offsetTop
            window.scrollTo({
                top: d,
                behavior: 'smooth'
            })
        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.joinus-cta
    background-color: #ff2b2a
    color: #ffffff
.block
    margin-left: 18.5%
    padding-top: 9%
    padding-bottom: 5%
    @media print
        padding-bottom: 0
        padding-top: 0
        margin-left: 9.6%
        margin-top: 1.2cm
        margin-bottom: 1.2cm
h2
    font-size: 160px
    font-weight: 500
    letter-spacing: -0.05em
    @include media-breakpoint-down($lg)
        font-size: 100px
    @include media-breakpoint-down($md)
        font-size: 70px
    @include media-breakpoint-down($sm)
        font-size: 50px
    @media print
        font-size: 50px
.cta
    margin-top: 9%
    /deep/ svg
        transform: rotate(90deg)
    @media print
        display: none
</style>
